import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppFooter from "../components/AppFooter";
export default function UserManual() {
  const navigate = useNavigate();

  const sections = [
    {
      title: "1. Terms and Conditions",
      content: (
        <>
          <p className="mb-3">
            Welcome to AICA – Your 24x7 AI-Powered Health Assistant. By using AICA, you agree to the following:
          </p>

          <ul className="list-disc list-inside space-y-1">
            <li><b>Eligibility:</b> 18+ or guardian consent required.</li>
            <li><b>Data Privacy:</b> Data processed securely under applicable laws.</li>
            <li><b>Medical Disclaimer:</b> Not a diagnostic or emergency tool.</li>
            <li><b>Usage Rights:</b> Licensed, not sold.</li>
            <li><b>Modifications:</b> Features may change anytime.</li>
            <li><b>Liability:</b> AICA is not responsible for medical decisions.</li>
          </ul>
        </>
      ),
    },

    {
      title: "2. How to Avail AICA Benefits",
      content: (
        <ol className="list-decimal list-inside space-y-2">
          <li><b>Get Access:</b> Via QR, hospital, clinic, employer, insurer, or website.</li>
          <li><b>Registration:</b> Sign up, link records, enable WhatsApp notifications.</li>
          <li><b>Care Access:</b> Start using AI health assistant instantly.</li>
        </ol>
      ),
    },

    {
      title: "3. Activating Benefits",
      content: (
        <ul className="list-disc list-inside space-y-1">
          <li>Symptom checker (text/voice)</li>
          <li>Prescription & report alerts</li>
          <li>Medication reminders</li>
          <li>24x7 AI health support</li>
        </ul>
      ),
    },

    {
      title: "4. Frequently Asked Questions",
      content: (
        <div className="space-y-2">
          <p><b>Q:</b> Is AICA a doctor? <br /> <b>A:</b> No, it supports doctors but does not replace them.</p>
          <p><b>Q:</b> Is it free? <br /> <b>A:</b> Available via hospitals/insurers or subscription.</p>
          <p><b>Q:</b> Emergency use? <br /> <b>A:</b> Not for emergencies.</p>
          <p><b>Q:</b> Data safety? <br /> <b>A:</b> Encrypted and not sold.</p>
          <p><b>Q:</b> Family use? <br /> <b>A:</b> Yes, multi-user support available.</p>
        </div>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-white/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-cyan-300/30 rounded-full blur-3xl"></div>

      {/* Grid */}
      <div className="absolute inset-0 opacity-[0.04] bg-[linear-gradient(to_right,#0f172a_1px,transparent_1px),linear-gradient(to_bottom,#0f172a_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-800">
            User Manual
          </h1>

          <p className="mt-4 text-slate-600 max-w-3xl mx-auto">
            Complete guide to using AICA HEALTH platform, features, activation steps, and FAQs.
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((sec, i) => (
            <div
              key={i}
              className="relative overflow-hidden rounded-3xl border border-white/40 bg-white/60 backdrop-blur-2xl shadow-xl p-6 sm:p-8 hover:bg-white/70 transition-all duration-300"
            >
              <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-4">
                {sec.title}
              </h2>

              <div className="text-slate-600 leading-relaxed text-sm sm:text-base">
                {sec.content}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-10 flex justify-center">
       
                 <button
                   onClick={() => navigate("/")}
                   className="
                   flex items-center gap-2
                   px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-cyan-500 to-blue-500
                   text-white
                   font-semibold
                   shadow-lg
                   hover:scale-105
                   hover:shadow-cyan-300/50
                   transition-all duration-300
                 "
                 >
                   <ArrowLeft size={18} />
                   Go Back
                 </button>
                </div>

       {/* <AppFooter /> */}

      </div>
    </div>
  );
}